module.exports = __webpack_public_path__ + "img/todo-desktop.1cf6617c.png";